import { Menu, UnstyledButton } from '@mantine/core';
import { IconCheck, IconChevronDown } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { ShipGlyph } from './VesselBadge.js';
import classes from './VesselCard.module.css';

export interface VesselOption {
  id: string;
  name: string;
  imo: string | null;
}

export interface VesselCardProps {
  vessel: VesselOption;
  /** Web ofiste filo; verilirse kart gemi seçicidir. Gemide tek gemi, seçici yok. */
  options?: readonly VesselOption[] | undefined;
  onSelect?: ((id: string) => void) | undefined;
}

/**
 * Sayfa başlığının sağındaki gemi kartı (personel-mlc-calisma-dinlenme.jpeg, sefer-noon-report):
 * gemi görseli, ad, IMO; filoda açılır okla gemi seçici (ok yalnız seçilebilirken). Gemi fotoğrafı
 * veri modelinde yok; yerine açık mavi zeminde gemi çizimi (M6d planı, gerekçeli fark). Ölçü:
 * referansta ≈ 283×54 px → en az 68 px yükseklik, 280–350 px genişlik (M6f G1-25).
 */
export function VesselCard({ vessel, options, onSelect }: VesselCardProps) {
  const { t } = useTranslation();
  const body = (
    <>
      <span className={classes.thumb} aria-hidden>
        <ShipGlyph size={46} />
      </span>
      <span className={classes.text}>
        <span className={classes.name} title={vessel.name}>
          {vessel.name}
        </span>
        {vessel.imo ? (
          <span className={classes.imo}>{t('shell.imo', { imo: vessel.imo })}</span>
        ) : null}
      </span>
    </>
  );

  if (!options || options.length < 2 || !onSelect) {
    return (
      <div className={classes.card} data-vessel-card>
        {body}
      </div>
    );
  }
  return (
    <Menu position="bottom-end" width={260} withinPortal>
      <Menu.Target>
        <UnstyledButton
          className={classes.card}
          data-vessel-card
          data-selectable
          aria-label={`${t('shell.selectVessel')}: ${vessel.name}`}
        >
          {body}
          <IconChevronDown size={16} className={classes.chevron} aria-hidden />
        </UnstyledButton>
      </Menu.Target>
      <Menu.Dropdown>
        {options.map((option) => (
          <Menu.Item
            key={option.id}
            onClick={() => onSelect(option.id)}
            rightSection={option.id === vessel.id ? <IconCheck size={14} aria-hidden /> : null}
          >
            {option.name}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
}
